import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { InterfaceIndicator } from 'app/models/indicator.model';
import { EmployeeService } from 'app/services/employee.service';
import { IndicatorService } from 'app/services/indicator.service';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-select-indicators',
  templateUrl: './select-indicators.component.html',
  styleUrls: ['./select-indicators.component.scss']
})
export class SelectIndicatorsComponent implements OnInit {

  isSaving = false;
  indicators: InterfaceIndicator[] = [];
  subscriptions: Subscription[] = [];
  @Input() indicatorsIds: string[];
  finishLoading = false;

  constructor(
    protected employeeService: EmployeeService,
    protected indicatorService: IndicatorService,
    public ngbActiveModal: NgbActiveModal
  ) { }

  ngOnInit(): void {
    this.getIndicators();
  }

  searchIndicator(indicatorName: string): void {
    this.indicators = [];
    this.finishLoading = false;
    if (indicatorName.length > 0) {
      this.subscriptions.push(
        this.indicatorService.searchIndicator(indicatorName).pipe(take(1)).subscribe((result: any) => {
          this.indicators = result;
          this.finishLoading = true;
        }, (error: any) => {
          console.error(error);
        })
      );
    } else {
      this.getIndicators();
    }
  }

  getIndicators(): void {
    this.indicators = [];
    this.subscriptions.push(
      this.indicatorService.getAllIndicators().pipe(take(1)).subscribe((result: InterfaceIndicator[]) => {
        this.indicators = this.indicators.concat(result);
        this.finishLoading = true;
      }, (error: any) => {
        console.error(error);
      })
    );
  }

  scrollIndicators(): void {
    this.subscriptions.push(
      this.indicatorService.getAllIndicators(this.indicators[this.indicators.length - 1].indicator!).pipe(take(1)).subscribe((result: InterfaceIndicator[]) => {
        this.indicators = this.indicators.concat(result);
      }, (error: any) => {
        console.error(error);
      })
    );
  }

  addOrRemoveIndicator(indicator: InterfaceIndicator): void {
    const findIndex = this.indicatorsIds.findIndex((indicatorsOfItem: string) => indicatorsOfItem === indicator.id!);
    if (findIndex !== -1) {
      this.indicatorsIds.splice(findIndex, 1);
    } else {
      this.indicatorsIds.push(indicator.id!);
    }
  }

  checkStatusCheckbox(indicator: InterfaceIndicator): boolean {
    const findIndex = this.indicatorsIds.findIndex((indicatorsOfItem: string) => indicatorsOfItem === indicator.id!);
    if (findIndex !== -1) {
      return true;
    } else {
      return false;
    }
  }

  save(): void {
    this.ngbActiveModal.close(this.indicatorsIds);
  }

}
